<template>
    <div>
        <ImageDisplay
            class="hoverable"
            :image-id="imageId"
            v-bind="$attrs"
            :is-thumb="!noThumb"
            v-on:click="openOverlay()">
        </ImageDisplay>

        <Teleport to="body">
            <Transition>
                <div v-if="imageLoaded">
                    <Transition>
                        <div v-show="displayOverlay" class="overlay" v-on:click="closeOverlay()">
                            <ImageDisplay
                                class="overlay-image"
                                :image-id="imageId"
                                :is-thumb="false">
                            </ImageDisplay>
                        </div>
                    </Transition>
                </div>
            </Transition>
        </Teleport>
    </div>
</template>

<script>

import ImageDisplay from './ImageDisplay.vue';

export default {
    name: 'ImageExpandable',
    inheritAttrs: false,        // handle inheritance through $attrs (apply to img tag)
    components: {
        ImageDisplay
    },
    props: {
        imageId: {  // the id or hash relating to a file 
            type: [String, Number],
            required: true,
            validator: (value) => (typeof value == 'string') || Number.isInteger(value)
        },
        noThumb: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            displayOverlay: true,   // show the overlay with the full-res image?
            imageLoaded: false      // has the image been opened atleast once?  (keep track to avoid re-rendering component)
        }
    },
    methods: {
        openOverlay() {
            this.displayOverlay = true
            document.body.style.overflow = 'hidden'
            this.imageLoaded = true
        },
        closeOverlay() {
            this.displayOverlay = false
            document.body.style.overflow = ''
        }
    },
    created() {
        
    }
}
</script>

<style scoped>

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: rgba(0, 0, 0, 0.2);
    transition: 400ms ease;

    display: flex;
    justify-content: center; /* Horizontally center */
    align-items: center; /* Vertically center */
    z-index: 1070; /* Above modals (e.g. Release Notes modal at 1062) so expanded image is not constrained */
}

.overlay div {
    z-index: 4999;
}

.overlay-image {
    max-width: 70%;
    object-fit: contain;
    z-index: 5000;
}


.v-enter-active, .v-leave-active {
  transition: opacity 400ms ease;
}

.v-enter-from, .v-leave-to {
  opacity: 0;
}


</style>
